import { render, staticRenderFns } from "./CampusCircuits.vue?vue&type=template&id=706c43b7&scoped=true&"
import script from "./CampusCircuits.vue?vue&type=script&lang=ts&"
export * from "./CampusCircuits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c43b7",
  null
  
)

export default component.exports